import {createContext, useCallback, useContext, useEffect, useState} from "react";
import {UserContext} from "./UserContext";
import {getLocalSelectedOffice, setLocalSelectedOffice} from "../utils/localStorage/office";
import {getSupportedOffices} from "../utils/api/support";

export const OfficeContext = createContext({
    offices: {},
    selectedOffice: null,
    onSelect: () => {
    }
});

const OfficeContextProvider = (props) => {
    const [offices, setOffices] = useState({});
    const [selectedOffice, setSelectedOffice] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const userContext = useContext(UserContext);

    const handleSelectedOfficeChange = useCallback((newOffice) => {
        setSelectedOffice(newOffice);
        setLocalSelectedOffice(newOffice);
    }, []);

    useEffect(() => {
        const handleGetSupportedOfficesSuccess = ({offices}) => {
            setOffices(offices);
            const localSelectedOffice = getLocalSelectedOffice();
            const defaultSelectedOffice = Object.keys(offices)[0];
            const selectedOffice = offices[localSelectedOffice] ? localSelectedOffice : defaultSelectedOffice;
            handleSelectedOfficeChange(selectedOffice);
            setIsLoading(false);
        };
        const handleGetSupportedOfficesError = () => {
            setIsLoading(false);
        };
        getSupportedOffices(handleGetSupportedOfficesSuccess, handleGetSupportedOfficesError);

    }, [handleSelectedOfficeChange, userContext.loggedUser]);

    return <OfficeContext.Provider value={{
        offices,
        selectedOffice,
        onSelect: handleSelectedOfficeChange
    }}>{props.children}</OfficeContext.Provider>

}
export default OfficeContextProvider
